import * as d3 from 'd3'

export default {
  methods: {
    

    call_LINK(selection, row_, pro_, col_) {

      if(col_.link == 'N' || pro_==0) return
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('fill', 'red').attr('font-weight', 500)
      })
      .on('mouseout', function() {
        d3.select(this).attr('fill', '#333').attr('font-weight', 400)
      })
      .on('click', () => {
        // console.log(row_.AREA, row_.ZONE, row_.YARD, )

        this.link_Modal(row_, col_)
      }) 
      
    },

    link_Modal(d_, col_) {

      // set for link key value   ex) let dataSource = {KEY1:d.PKG,KEY2:d.DISC...}
      let dataSource = {KEY_AREA: d_.AREA, KEY_ZONE: d_.ZONE, KEY_YARD: d_.YARD} // DO not Remark if possible

      // set for request from A/G jsonProps
      let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
      if(!request_) return

      // set for filterString 
      let filterString_ = ''

      if (col_.code == 'F_ACT') {
        filterString_ = `[S_OUT] IS NOT NULL`
      } else if (col_.code == 'F_REM') {
        filterString_ = `[S_OUT] IS NULL`
      } else if (col_.code == 'I_ACT') {
        filterString_ = `[INSTALL_DATE] IS NOT NULL`
      } else if (col_.code == 'I_REM') {
        filterString_ = `[INSTALL_DATE] IS NULL`
      }

      // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // combine filterString and inputFilter &&& emit request-action
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },
 
    
  }
}